import { NavLink, Outlet } from 'react-router-dom';
import { FileText, DollarSign, Clock } from 'lucide-react';
import { SectionHeader } from '@/components/ui/Card';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/financials/invoices', label: 'Invoices', icon: FileText },
  { to: '/financials/payments', label: 'Payments', icon: DollarSign },
  { to: '/financials/aging',    label: 'Aging',    icon: Clock },
];

export function FinancialsLayout() {
  return (
    <div className="space-y-8">
      <SectionHeader
        kicker="Financials · Accounts Receivable"
        title="Money in, money out."
        description="Invoices, payments, and aging — every dollar across the operation."
      />

      {/* Sub-tabs */}
      <div className="border-b border-border">
        <nav className="flex gap-1 -mb-px">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'inline-flex items-center gap-2.5 px-5 h-11 text-xs uppercase tracking-[0.15em] transition-colors',
                    'border-b-2',
                    isActive
                      ? 'border-brass-400 text-text'
                      : 'border-transparent text-text-muted hover:text-text',
                  )
                }
              >
                <Icon size={13} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      {/* Sub-route outlet */}
      <div>
        <Outlet />
      </div>
    </div>
  );
}
